import React, { useEffect, useState } from "react";
import "./Login.css";
import "../Auth.css";
import { AiOutlineUser } from "react-icons/ai";
import { HiLockClosed } from "react-icons/hi";
import Loader from "../../Components/Loader/Loader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import useAxiosHelper from "./../../Common/AxiosHelper";
import { setAuthToken } from "./../../Redux/StatusState";
import { toastFailed, toastSuccess } from "./../../Config/BasicInfo";
import { ApiPaths } from "./../../Config/ApiPath";
import { setLoginDisplay } from "../../Redux/LoginSlice";
import { useDispatch } from "react-redux";
import { setUserPersonalInfo } from "../../Redux/ProfileDataSlice";
import AuthLayout from "../../Components/AuthLayout";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState(location.state?.username || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisility, setPasswordVisiblity] = useState(false);
  const dispatch = useDispatch();
  const { AxiosPost } = useAxiosHelper();

  useEffect(() => {
    if (location.state?.username) {
      setUsername(location.state.username);
    }
  }, [location.state]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        Login();
      }
    };

    document.addEventListener("keypress", handleKeyPress);
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [username, password]);

  async function Login() {
    if (username?.length > 0 && password?.length > 0) {
      setLoading(true);
      try {
        setLoading(true);
        const body = {
          password: password.trim(),
          username: username.trim(),
        };
        const res = await AxiosPost(ApiPaths.login, body);
        console.log("login", res);
        if (res.status == 200) {
          toastSuccess(res?.message);
          dispatch(setAuthToken(res?.token));
          localStorage.setItem("token", res?.token);
          localStorage.setItem("userId", JSON.stringify(res?.user?.uid));
          localStorage.setItem("userData", JSON.stringify(res?.user));
          dispatch(setUserPersonalInfo(res?.user));
          dispatch(setLoginDisplay(false));
          navigate("/dashboard");
          setLoading(false);
        } else {
          toastFailed(res?.message);
          setLoading(false);
        }
        setLoading(false);
      } catch (error) {
        console.log("login error", error);
        const errData = error?.response?.data;
        if (errData?.code === "EMAIL_NOT_VERIFIED") {
          toastFailed(errData?.message || "Please verify your email first");
          const verifyPayload = {
            email: errData?.email || "",
            username: errData?.username || username.trim(),
          };
          try {
            sessionStorage.setItem(
              "hablink_email_verify",
              JSON.stringify(verifyPayload)
            );
          } catch (_) {}
          navigate("/verify-email", { state: verifyPayload });
        } else {
          toastFailed(
            errData?.message || "An error occurred during login"
          );
        }
        setLoading(false);
      }
    } else {
      toastFailed("Invalid Data");
    }
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <AuthLayout
        title="Welcome back"
        subtitle="Sign in to continue managing your portfolio."
        footerText="Don't have an account?"
        footerLinkText="Create one"
        footerTo="/register"
      >
        <div className="authForm">
          <div className="authField">
            <label className="fieldLabel">Username or Email</label>
            <div className="fieldBox">
              <i className="fieldIcon">
                <AiOutlineUser />
              </i>
              <input
                type="text"
                autoCapitalize="none"
                autoCorrect="off"
                autoComplete="username"
                placeholder="Enter your username or email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          <div className="authField">
            <label className="fieldLabel">Password</label>
            <div className="fieldBox">
              <i className="fieldIcon">
                <HiLockClosed />
              </i>
              <input
                type={passwordVisility ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                className="fieldEye"
                onClick={() => setPasswordVisiblity(!passwordVisility)}
              >
                {passwordVisility ? <FaRegEye /> : <FaRegEyeSlash />}
              </i>
            </div>
          </div>

          <div className="authForgot">
            <Link to="/forget_password">Forgot password?</Link>
          </div>

          <button className="authBtn" onClick={Login}>
            Sign In
          </button>
        </div>
      </AuthLayout>
    </>
  );
};

export default Login;
